import React, { Component } from 'react';
import Modal, { ConfirmModal, ConfirmDisableModal } from '../components/container/Modal';
import { fetchPut } from '../cruds/remote';
import List from '../cruds/List';
import DeletableRowList from '../components/container/DeletableRow';
import CollapsibleRowList from '../components/container/CollapsibleRow';
import PropTypes from 'prop-types';
import DownloadButton from '../components/output/DownloadButton';
import getLabel from '../translations/messages';
import { withRoles } from '../components/container/WithRole';

const filters = [
  { name: 'departmentSearch', placeholder: 'general.department' },
  {
    name: 'activitySearch',
    placeholder: 'general.activity',
    type: 'exclusion',
    toggleName: 'withActivities',
    toggleLabel: 'departmentActivities.withActivities',
  },
];

const ENTITY_NAME = 'departments';
const TITLE = 'departmentActivities.title';

class DepartmentActivitiesList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  filtersValidation = (filters, name) => {
    const { withActivities } = filters;
    if (withActivities === false) {
      filters.activitySearch = '';
    }
  };

  handleRemove = (department, activity, updateCallback) => {
    const content = <span>
                      {getLabel(this.context.locale, 'general.deleteAssociation')}
                      <span style={{ fontWeight: 600 }}> {department.name} </span>
                      {getLabel(this.context.locale, 'general.and')}
                      <span style={{ fontWeight: 600 }}> {activity.activityName}</span>?
                    </span>;

    this.setState({
      showModal: true,
      modalContent: content,
      modalSubmit: () => this.handleActualRemove(department, activity, updateCallback),
    });
  };

  exportButtons = (filters, context, toggleModal) => {
    return (
      <span>
        <DownloadButton from={'departmentActivities'}
            filters={filters}
            type="application/vnd.ms-excel"
            extension="xls"
            tooltip="departmentActivities.export"
            wide
            handleError={toggleModal}
        />
        <DownloadButton
            from={'departmentActivities'}
            filters={filters}
            type="application/pdf"
            extension="pdf"
            iconType="printer"
            tooltip="departmentActivities.print"
            wide
            handleError={toggleModal}
        />
      </span>
    );
  };

  handleActualRemove = (department, activity, updateCallback) => {
    const updatedActivities = department.activities
                                        .filter(a => a.activityId !== activity.activityId)
                                        .map(a => String(a.activityId));

    const url = [ENTITY_NAME, department.id, 'activities'].join('/');

    fetchPut(url, { value: updatedActivities })
        .then(res => this.setState({
            showModal: false,
            modalContent: '',
            modalSubmit: null,
          }, updateCallback),
        ).catch(err => this.setState({
            showModal: false,
            modalContent: '',
            modalSubmit: null,
            title: 'general.errorOccurred',
            showDisableModal: true,
            modalDisableContent: err.message,
            modalDisableSubmit: () => this.handleActualDisableRemove(department, activity, updateCallback),
        }));

  };

  handleActualDisableRemove = (department, activity, updateCallback) => {
	    const updatedActivities = department.activities
        .filter(a => a.activityId !== activity.activityId)
        .map(a => String(a.activityId));

	    const url = [ENTITY_NAME, department.id, 'activitiesDisableRemove'].join('/');

	    fetchPut(url, { value: updatedActivities })
	  .then(res => this.setState({
		  showDisableModal: false,
		  modalDisableContent: '',
		  modalDisableSubmit: null,
          }, updateCallback)

        ).catch(err => {
        	this.setState({
      		  showDisableModal: false,
    		  modalDisableContent: '',
    		  modalDisableSubmit: null,
  	          title: 'general.errorOccurred',
  	          showErrorModal: true,
  	          error: err.message,        
        });
        });
  };
  
  
  closeDisableModal = () => {
	    this.setState({ showDisableModal: false, error: '' });
	  };
  
  closeModal = () => {
    this.setState({ showModal: false, error: '' });
  };

  closeErrorModal = () => {
    this.setState({ showErrorModal: false, error: '' });
  };

  render() {
    const table = <CollapsibleRowList
                      optionLabelName={['companyName', 'name']}
                      hideViewButton={true}
                      hideEditButton={!withRoles(['A', 'B'])}
                  >
                    <DeletableRowList
                      name="activities"
                      labelProperty="activityName"
                      handleRemove={this.handleRemove}
                      emptyMessage="departmentActivities.emptyResults"
                      showDeleteButton={withRoles(['A', 'B'])}
                    />
                  </CollapsibleRowList>;

    return (
      <div>
	      <ConfirmDisableModal
	      isOpen={this.state.showDisableModal}
	      title="general.confirmDeletion.title"
	      handleCloseModal={this.closeDisableModal}
	      submitAction={this.state.modalDisableSubmit}
	      >
      	<div style={{ padding: 20 }}>{this.state.modalDisableContent}</div>
    	</ConfirmDisableModal>
        <ConfirmModal
          isOpen={this.state.showModal}
          title="general.confirmDeletion.title"
          handleCloseModal={this.closeModal}
          submitAction={this.state.modalSubmit}
        >
          <div style={{ padding: 20 }}>{this.state.modalContent}</div>
        </ConfirmModal>
        <Modal
          isOpen={this.state.showErrorModal}
          title="general.errorOccurred"
          handleCloseModal={this.closeErrorModal}
        >
          <div style={{ padding: 20 }}>{this.state.error}</div>
        </Modal>
        <List
          title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={this.props.match.url}
          hideAddButton={true}
          component={table}
          filters={filters}
          filtersValidation={this.filtersValidation}
          additionalButtons={this.exportButtons}
        />
      </div>
    );
  }

}

DepartmentActivitiesList.contextTypes = {
  locale: PropTypes.string,
};

export default DepartmentActivitiesList;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentActivitiesList.js